module.exports = __webpack_public_path__ + "h5/img/recording.f7ef8fc2.png";